<template>
    <div>
        <a href="javascript:"
           :class="{active: activePage === 'vacancyInfo' }"
           @click="$emit('setVacancyPage', 'vacancyInfo')"
        >
            <i class="fal fa-file-contract"></i> Vacature gegevens
        </a>
        <a href="javascript:"
           :class="{active: activePage === 'vacancyCandidatePlacing' }"
           @click="$emit('setVacancyPage', 'vacancyCandidatePlacing')"
        >
            <i class="fal fa-user"></i> Kandidaat plaatsen
        </a>
    </div>
</template>
<script>
    export default {
        props: {
            activePage: String,
        },
        data() {
            return {
                vacancyPage: 'vacancyInfo',
            }
        }
    }
</script>